var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEipsRedo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3464_932",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34.5714,
    height: 34.5714,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 35.2812 0.71875)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3464_932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0168 28.0915C23.3456 28.0915 25.3442 27.3353 27.0128 25.8228C28.6813 24.3103 29.5156 22.4256 29.5156 20.1689C29.5156 17.9122 28.6813 16.0275 27.0128 14.515C25.3442 13.0025 23.3456 12.2463 21.0168 12.2463L11.9418 12.2463L15.6871 8.50104L13.6704 6.48437L6.46801 13.6868L13.6704 20.8891L15.6871 18.8725L11.9418 15.1272L21.0168 15.1272C22.5293 15.1272 23.8437 15.6074 24.9601 16.5677C26.0765 17.528 26.6347 18.7284 26.6347 20.1689C26.6347 21.6094 26.0765 22.8098 24.9601 23.7701C23.8437 24.7304 22.5293 25.2106 21.0168 25.2106L10.7894 25.2106L10.7894 28.0915L21.0168 28.0915Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEipsRedo);
export default __webpack_public_path__ + "static/media/eipsRedo.199e4042b87b4279b5495a235d13084f.svg";
export { ForwardRef as ReactComponent };